import { Component, OnInit } from '@angular/core';
import { EventService } from 'src/app/service/event.service';
import { Events } from 'src/app/service/websocket.service';
import { Utils } from 'src/app/utils';

class AgentInstruction {
  id:string;
  title:string;
  logoSrc:string;
  description:string;
  codeSnippet:string;
  downloadName:string;
  downloadLink:string;
  downloadId:string;
  downloadInstruction:string;
}

@Component({
    selector: 'app-settings-agents',
    templateUrl: './settings-agents.component.html',
    styleUrls: ['../settings/settings.component.css', './settings-agents.component.css'],
    standalone: false
})
export class SettingsAgentsComponent implements OnInit {

  instructions:AgentInstruction[] = [];
  hostName:string = window.location.hostname;
  hostPort:string = window.location.port;
  hostProtocol:string = window.location.protocol;

  constructor(private eventService: EventService,) { }

  ngOnInit(): void {
    //windows
    this.instructions.push({
      id: 'windowsCodeSnippet',
      title: $localize`Agent for Windows`,
      logoSrc: "./assets/icons/Windows_logo.svg",
      description: $localize`In order to install the Agent, please execute the following PowerShell command line as Administrator from your system:`,
      codeSnippet: '(New-Object System.Net.WebClient).DownloadFile("' + this.getHostURL() + '/downloadAgent/?ostype=win&filetype=installer","$pwd\\OpenText_SystemCenter_Agent.msi");Start-Process "msiexec.exe" -ArgumentList "/qn /l*vx $pwd\\sc_agent_install.log /i $pwd\\OpenText_SystemCenter_Agent.msi HTTP_PORT_NUMBER=`"' + this.hostPort + '`" SERVER_NAME=`"' + this.hostName + '`""',
      downloadName: "OpenText_SystemCenter_Agent.msi",
      downloadLink: "/downloadAgent/?ostype=win&filetype=installer",
      downloadId: "downloadWinAgent",
      downloadInstruction: $localize`and execute the installer from your system.`,
    });
    //linux
    this.instructions.push({
      id: 'linuxCodeSnippet',
      title: $localize`Agent for Linux`,
      logoSrc: "./assets/icons/Linux_logo.svg",
      description: $localize`In order to install the Agent, please execute the following command line from your system:`,
      codeSnippet: 'bash <(curl -X GET \'' + this.getHostURL() + '/downloadAgent/?ostype=linux&filetype=installer\')',
      downloadName: "SystemCenter_Agent.sh",
      downloadLink: "/downloadAgent/?ostype=linux&filetype=installer",
      downloadId: "downloadLinuxAgent",
      downloadInstruction: $localize`and execute the script from your system.`,
    });
  }

  getHostURL(): string {
    return (this.hostName && this.hostName && this.hostName) ? this.hostProtocol + "//" + this.hostName + ":" + this.hostPort : "";
  }

  copyCodeSnippet(inputElement): void {
    Utils.copyToClipboard(inputElement.textContent);
    Utils.addHeaderMessageEventBanner(this.eventService, Events.InfoMsg,
       $localize`The command line was copied to your clipboard.`);
  }
}
